<!-- スライドメニューのアイテム -->
<template>
  <li
    class="crly-m-common-slide-menu-item"
    :class="menuItem.type"
    @click="clickSlideMenuItem"
  >
    <span
      class="crly-m-common-slide-menu-item__child-icon"
      v-if="isChild"
    ></span>
    <label>{{ menuItem.name }}</label>
  </li>
</template>

<script>
export default {
  name: "CrlyMCommonSlideMenu",
  props: {
    menuItem: {
      type: Object,
      default: () => {}
    },
    isChild: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * メニューアイテムクリックイベント
     */
    clickSlideMenuItem() {
      this.$emit("menuClose", "");
      if (this.menuItem.type === "logout") {
        this.logout();
      } else if(this.menuItem.type === "opinionBox") {
        this.windowOpen(process.env.VUE_APP_LIFEYELL_OPINION_URL, "_blank");
      } else if (this.menuItem.linkName) {
        this.$router.push({ name: this.menuItem.linkName });
      } else if (this.menuItem.linkBS) {
        this.windowOpen(this.CONST_LINK_BS[this.menuItem.linkBS]);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/molecules/common/slideMenuItem.scss";
</style>
